import { css } from '../../../styles/theme';
import { rem } from 'polished';

export const StylesAC = css`
    .noLinkButton {
        border: 1px solid ${({ theme }) => theme.colors.red};
        background: ${({ theme }) => theme.colors.white};
        color: ${({ theme }) => theme.colors.red};
        font-size: ${({ theme }) => theme.fontSizes.h4};
        text-transform: unset;
        height: ${rem(48)};

        &:hover,
        &:focus-visible {
            background: ${({ theme }) => theme.colors.red};
            color: ${({ theme }) => theme.colors.white};
            border-color: ${({ theme }) => theme.colors.red};
        }
    }

    .linkButton {
        color: ${({ theme }) => theme.colors.red};
        font-weight: ${({ theme }) => theme.fontWeights.textBold};
        font-size: ${({ theme }) => theme.fontSizes.h4};
        text-decoration: unset;
        background: none;
        border: none;
        cursor: pointer;
        padding: ${rem(12)} 0 0 0;

        svg {
            width: ${rem(12)};
            height: ${rem(12)};
            margin-left: ${rem(8)};

            path {
                fill: ${({ theme }) => theme.colors.red};
            }
        }

        &:hover,
        &:focus-visible {
            border: none;
            color: ${({ theme }) => theme.colors.grey5};

            svg {
                path {
                    fill: ${({ theme }) => theme.colors.grey5};
                }
            }
        }
    }
`;
